export var DOC_STATUS_INIT = 'DOC_STATUS/INIT';
export var DOC_STATUS_ERROR = 'DOC_STATUS/ERROR';
export var DOC_STATUS_SYNCING = 'DOC_STATUS/SYNCING';
export var DOC_STATUS_SYNCED = 'DOC_STATUS/SYNCED';